import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconDropdown = props => (
  <SvgIcon {...props} viewBox="0 0 9.9999771 16">
    <path d="m9.1046 6h-8.2092c-0.21461 0-0.41774-0.0586-0.57643-0.1621-0.08777-0.0567-0.16186-0.127-0.21679-0.207-0.15454-0.2247-0.13245-0.5 0.05725-0.709l4.2101-4.6582c0.1499-0.16604 0.397-0.2637 0.6602-0.2637 0.1522 0 0.2987 0.033203 0.4239 0.09375 0.0916 0.04492 0.1718 0.10352 0.2345 0.17383l4.1553 4.6582c0.1876 0.2109 0.2086 0.4824 0.0533 0.707-0.155 0.2266-0.4598 0.3672-0.7921 0.3672zm-8.2092 4h8.2092c0.33227 0 0.63708 0.1406 0.79211 0.3672 0.15477 0.2246 0.13437 0.4961-0.05334 0.707l-4.1553 4.658c-0.1006 0.114-0.246 0.196-0.4111 0.239-0.0789 0.019-0.1622 0.029-0.2473 0.029-0.2632 0-0.5103-0.098-0.6602-0.264l-4.2101-4.658c-0.18967-0.209-0.21176-0.484-0.05722-0.709 0.15442-0.226 0.46008-0.369 0.79321-0.369z" />
  </SvgIcon>
);

export default IconDropdown;



// WEBPACK FOOTER //
// ./src/components/icons/IconDropdown.js